import {z} from '@hono/zod-openapi';

export const VoiceDebugReadyRequestSchema = z
  .object({schemaVersion: z.literal('1.0.0')})
  .strict()
  .openapi('VoiceDebugReadyRequestSchema');

export type VoiceDebugReadyRequest = z.infer<typeof VoiceDebugReadyRequestSchema>;
